import { api } from '@/lib/api';

export type RootUserRole = 'admin' | 'user';

export interface RootUser {
  id: number;
  username: string;
  role: RootUserRole;
  state: boolean;
  createdAt: string;
}

/** The 201 body from createRootUser. Deliberately has no `createdAt`: the row is
 *  written with MySQL NOW(), so only the listing reports the real timestamp. */
export interface CreatedRootUser {
  id: number;
  username: string;
  role: RootUserRole;
  state: boolean;
}

export interface CreateRootUserBody {
  username: string;
  password: string;
  role: RootUserRole;
  state: boolean;
}

export function listRootUsers() {
  return api.get<RootUser[]>('/api/root-users');
}

export function createRootUser(body: CreateRootUserBody) {
  return api.post<CreatedRootUser>('/api/root-users', body);
}
